/**
 * Validates the vehicle delivery date
 * @param date - The date to validate
 * @returns True if the date is valid, false otherwise
 */
export const validateVehicleDeliveryDate = (date: Date | null): boolean => {
    if (!date) return true;
    const now = new Date();
    const oneYearFromNow = new Date();
    oneYearFromNow.setFullYear(now.getFullYear() + 1);
    return date >= now && date <= oneYearFromNow;
};
